export default () => {
    const enterViewObserver = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const { target } = entry;
                    target.dataset.enterView = true;
                    observer.unobserve(target);
                }
            })
        }
    );

    [...document.querySelectorAll('[data-enter-view]')]
        .forEach(el => enterViewObserver.observe(el));
}
